/**
 * i18next 初始化（默认英文，回退英文）。
 *
 * 默认语言为 en：tsuvi.com 面向全球 makers，英语是 ROI 最高的主市场，
 * x-default / 根路径重定向 / 搜索引擎抓取的「默认脸」都指向 /en。
 * 详见 apps/web/SEO_CONTENT_PLAN.md §4.4。
 *
 * 资源内联 import（四套字典，无需懒加载）：
 *   en     English       ← 默认 / x-default
 *   zh     简体中文
 *   ja     日本語
 *   ko     한국어
 * 语言切换由 URL 前缀 /:lang 驱动（见 components/LangSync），切换时调 i18n.changeLanguage。
 * interpolation.escapeValue=false：React 已对插值变量转义。
 */

import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./locales/en.json";
import zh from "./locales/zh.json";
import ja from "./locales/ja.json";
import ko from "./locales/ko.json";

// en 排首：默认语言在语言选择下拉中排名第一（与 prerender.mjs 的 LANGS、
// worker seo.ts 的 SEO_LANGS 顺序一致；下游仅遍历，无顺序敏感逻辑）
export const SUPPORTED_LANGS = ["en", "zh", "ja", "ko"] as const;
export type Lang = (typeof SUPPORTED_LANGS)[number];
export const DEFAULT_LANG: Lang = "en";

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    zh: { translation: zh },
    ja: { translation: ja },
    ko: { translation: ko },
  },
  lng: DEFAULT_LANG,
  fallbackLng: "en",
  interpolation: { escapeValue: false },
});

export default i18n;
